<script setup lang="ts">
interface Props
{
  agenciaCodigo: string
  roles?: number[]
}

const props = defineProps<Props>();

const emit = defineEmits(['close', 'success']);
</script>

<template>
  <AuthorizeView :allow="props.roles ?? []">
    <template #authorized>
      <DrawerTitle2
        title="Novo email de agência"
        @close="() => emit('close')"
      />
      <div style="padding-left: 24px; padding-right: 24px">
        <CommandForm
          command="NovoAgenciaEmailCommand"
          :initial-model="{ agenciaCodigo: props.agenciaCodigo }"
          @close="() => emit('close')"
        >
          <template #form="{ model }">
            <a-form-item
              label="Email"
              name="email"
              :rules="{
                message: 'Email é obrigatório',
                required: true,
              }"
            >
              <a-input
                v-model:value="model.email"
                placeholder="Email"
              />
            </a-form-item>
          </template>
          <template #submitSuccess>
            <a-result
              status="success"
              title="Registro realizado com sucesso"
              sub-title="Agora você pode fechar essa janela"
            >
              <template #extra>
                <a-button @click="() => emit('close')">
                  Fechar
                </a-button>
              </template>
            </a-result>
          </template>
        </CommandForm>
        <div />
      </div>
    </template>
  </AuthorizeView>
</template>
